export const CONSTANT = {
  BUSINESS_GOOGLE_MAP_URL:
    'https://www.google.com/maps/place/ALM+Print/@40.3177927,-3.4682138,15z/data=!4m5!3m4!1s0x0:0xf29fa390d49ca297!8m2!3d40.3177927!4d-3.4682138'
};
